import { render, staticRenderFns } from "./PublicationStandards.vue?vue&type=template&id=094d2dde&scoped=true&"
import script from "./PublicationStandards.vue?vue&type=script&lang=js&"
export * from "./PublicationStandards.vue?vue&type=script&lang=js&"
import style0 from "./PublicationStandards.vue?vue&type=style&index=0&id=094d2dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094d2dde",
  null
  
)

export default component.exports